import { ReactElement, useMemo, useState } from "react";

import { IconDefinition } from "../../utils/icon-utils";
import { Button } from "../catalyst/Button";
import { Dialog } from "../catalyst/Dialog";
import { DialogBody } from "../catalyst/DialogBody";
import { DialogDescription } from "../catalyst/DialogDescription";
import { DialogTitle } from "../catalyst/DialogTitle";
import { Input } from "../catalyst/Input";
import { Text } from "../catalyst/Text";

export const IconPicker = ({
  iconSet,
  onChange,
  open,
  setOpen,
}: {
  iconSet: IconDefinition[];
  onChange: (icon: string) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}): ReactElement => {
  const [query, setQuery] = useState("");

  const filteredIcons = useMemo(() => {
    return iconSet.filter((icon) =>
      icon.label.toLowerCase().includes(query.toLowerCase()),
    );
  }, [query, iconSet]);

  return (
    <Dialog onClose={setOpen} open={open} size="md">
      <DialogTitle>Select an Icon</DialogTitle>
      <DialogDescription>Choose an icon for this entity</DialogDescription>
      <DialogBody>
        <Input
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search..."
          type="search"
          value={query}
        />
        <div className="grid max-h-[400px] grid-cols-6 gap-2 overflow-y-scroll py-4 pb-12">
          {filteredIcons.map((icon) => (
            <Button
              key={icon.name}
              onClick={() => {
                onChange(icon.name);
                setOpen(false);
              }}
              role="button"
              type="button"
            >
              {icon.render()}
              <span className="sr-only">{icon.name}</span>
            </Button>
          ))}

          {filteredIcons.length === 0 && (
            <div className="col-span-full flex grow flex-col items-center justify-center gap-2 text-center">
              <Text>No icons found...</Text>
              <Button onClick={() => setQuery("")} plain>
                Clear Search
              </Button>
            </div>
          )}
        </div>
      </DialogBody>
    </Dialog>
  );
};
